module.exports = __webpack_public_path__ + "img/ic_toast_successful.e46e22b6.svg";